var render = function render(){var _vm=this,_c=_vm._self._c;return _c('FormulateInput',{attrs:{"label":"Motto","type":"text","name":"motto","value":_vm.value,"help":_vm.help,"validation":"max:255,length","validation-messages":{
    max: 'Motto nesmí být delší než 255 znaků',
  },"error-behavior":"submit","disabled":_vm.disabled}})
}
var staticRenderFns = []

export { render, staticRenderFns }